import { render, staticRenderFns } from "./searchDeviceDetail.vue?vue&type=template&id=2f72654f&scoped=true&"
import script from "./searchDeviceDetail.vue?vue&type=script&lang=js&"
export * from "./searchDeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./searchDeviceDetail.vue?vue&type=style&index=0&id=2f72654f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f72654f",
  null
  
)

export default component.exports